import * as Yup from 'yup'

export interface CardFormData {
  cpf: string
  name: string
  card_number: string
  card_expiration: string
  card_cvv: string
  address_street: string
  address_number: string
  address_neighborhood: string
  address_zip: string
  address_city: string
  address_state: string
}

export const cardFormInitialValues: CardFormData = {
  cpf: '',
  name: '',
  card_number: '',
  card_expiration: '',
  card_cvv: '',
  address_street: '',
  address_number: '',
  address_neighborhood: '',
  address_zip: '',
  address_city: '',
  address_state: '',
}

export const cardFormValidationSchema = Yup.object().shape({
  cpf: Yup.string().required('O CPF do titular é obrigatório'),
  name: Yup.string().required('O nome do titular é obrigatório'),
  card_number: Yup.string().required('O número do Cartão é obrigatório'),
  card_expiration: Yup.string()
    .matches(/^\d{2}\/\d{2}$/, 'Formato de expiração inválido (MM/YY)')
    .required('A expiração é obrigatória'),
  card_cvv: Yup.string()
    .matches(/^\d{3}$/, 'O CVV deve ter 3 dígitos')
    .required('O CVV é obrigatório'),
  address_street: Yup.string().required('O campo de Rua é obrigatório'),
  address_number: Yup.string().required('O campo de Número é obrigatório'),
  address_neighborhood: Yup.string().required('O campo de Bairro é obrigatório'),
  address_zip: Yup.string().required('O campo de CEP é obrigatório'),
  address_city: Yup.string().required('O campo de Cidade é obrigatório'),
  address_state: Yup.string()
    .required('O campo de Estado é obrigatório')
    .matches(/^(?:A[CLPM]|BA|CE|DF|ES|GO|M[ATSG]|P[RBAEI]|R[JNSOR]|S[CEP]|TO)$/, 'O Estado selecionado é inválido'),
})
